import App from "./App.svelte";

const target = document.getElementById("app") || document.body;
const renderedPath = target.dataset ? target.dataset.path : null;
const currentPath = window.location.pathname.length > 1
  ? window.location.pathname.replace(/\/$/, "")
  : window.location.pathname;
const hydrate = renderedPath === currentPath;

if (!hydrate) target.innerHTML = "";

const app = new App({ target, hydrate });

export default app;
